import { CardBody } from "reactstrap";

export function ContentCardMain({ bgColor = "#FFFFFF", children }) {
  return (
    <CardBody
      className="p-3 d-flex flex-column flex-fill align-items-start justify-content-start overflow-hidden card-main-content"
      style={{ backgroundColor: bgColor, height: "100%" }}
    >
      {children}
    </CardBody>
  );
}
